import { normalizeNumber } from '../utils/normalize';

export function pluralize(value: any, ifSingular: string, ifPlural: string): string {
  const _val = normalizeNumber(value);
  return `${_val} ${_val === 1 ? ifSingular : ifPlural}`;
}

pluralize.create = (ifSingular: string, ifPlural: string) => (value: any) => pluralize(value, ifSingular, ifPlural);
